import { Injectable } from '@angular/core';
import Handlebars from 'handlebars';
import { marked } from 'marked';
import {
  buildTemplateContext,
  validateAnswers,
  SCHEMA_VERSION,
  TEMPLATE_VERSION,
} from '@bignest/bylaws-kit';
import { resolveWidgetAssetUrl } from 'src/app/core/utils/asset-path';
import { TemplateRendererService } from 'src/app/core/services/template-renderer.service';

@Injectable({ providedIn: 'root' })
export class BylawsRenderService {
  private templateCache: Promise<string> | null = null;

  constructor(private readonly templateRenderer: TemplateRendererService) {}

  private loadTemplate(): Promise<string> {
    if (!this.templateCache) {
      const url = resolveWidgetAssetUrl('templates/v1.0.0/bylaws-template.md');
      this.templateCache = fetch(url).then(async (res) => {
        if (!res.ok) {
          this.templateCache = null;
          throw new Error(
            `Failed to load bylaws template (${res.status} ${res.statusText})`,
          );
        }
        return res.text();
      });
    }
    return this.templateCache;
  }

  async render(answers: Record<string, unknown>): Promise<{
    schemaVersion: string;
    templateVersion: string;
    context: Record<string, unknown>;
    markdown: string;
    html: string;
    errors: string[];
  }> {
    const errors = validateAnswers(answers);
    const context = buildTemplateContext(answers);
    const template = await this.loadTemplate();
    const compiled = Handlebars.compile(template, { noEscape: true });
    const rendered = compiled(context);
    const markdown = this.templateRenderer.render(rendered, context);
    const html = marked.parse(markdown, { async: false });

    return {
      schemaVersion: SCHEMA_VERSION,
      templateVersion: TEMPLATE_VERSION,
      context,
      markdown,
      html,
      errors,
    };
  }
}
